module.exports = __webpack_public_path__ + "img/partner6.a57980b5.png";